import { defineComponent as _defineComponent } from 'vue';
import { capitalize } from "lodash";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuInput',
    props: {
        name: { type: String, required: true },
        filter: { type: Object, required: true },
        filters: { type: Object, required: true },
        error: { type: Object, default: null },
        identifier: { type: String, required: true },
    },
    emits: ["change", "on-enter", "on-esc"],
    setup(__props, { emit }) {
        const props = __props;
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        const helpToggle = ref(false);
        const modalTitle = `${capitalize(props.filter.placeholder)} Help`;
        watch(() => localValue.value, (newFilter) => {
            emit("change", props.name, newFilter);
        });
        watch(() => propValue.value, (newFilter) => {
            localValue.value = newFilter;
        });
        function hasError(field) {
            if (props.error && props.error.index == field) {
                return props.error.typeError || props.error.msg;
            }
            return "";
        }
        function onHelp(_, value) {
            helpToggle.value = false;
            localValue.value = value;
        }
        return { __sfc: true, props, emit, propValue, localValue, helpToggle, modalTitle, hasError, onHelp };
    }
});
